export const FILTRO_TEXTO_LIVRE = { chave: 'textoLivre', label: 'Texto' };
export const FILTRO_SITUACAO_PAGAMENTO = { chave: 'situacaoPagamento', label: 'Situação pagamento' };
export const FILTRO_VENDEDORES = { chave: 'vendedores', label: 'Vendedor' };
export const FILTRO_VENDEDOR = { chave: 'vendedor', label: 'Vendedor' };
export const FILTRO_VENDEDOR_ADMINAGENCIA = { chave: 'vendedorAgencia', label: 'Vendedor Agência' };
export const FILTRO_SITUACAO_PEDIDO = { chave: 'situacoes', label: 'Situação' };
export const FILTRO_FORMA_PAGAMENTO = { chave: 'formasPagamento', label: 'Forma de Pagamento' };
export const FILTRO_DATA_EMBARQUE = { chave: 'dataEmbarque', label: 'Data de Embarque' };
export const FILTRO_DATA_ENTRADA = { chave: 'dataCriacao', label: 'Data de Entrada' };
export const FILTRO_PERIODO_AGENDAMENTO = { chave: 'periodo', label: 'Periodo' };
export const FILTRO_DATA_CRIACAO = { chave: 'dataCriacao', label: 'Data de Criação' };
export const FILTRO_DATA_FECHAMENTO = { chave: 'dataFechamento', label: 'Data do Fechamento' };
export const FILTRO_DATA_VENDA = { chave: 'dataVenda', label: 'Data da Venda' };
export const FILTRO_NUMERO_PEDIDO = { chave: 'numeroPedido', label: 'Número do Pedido' };
export const FILTRO_NOME_PASSAGEIRO = { chave: 'nomePassageiro', label: 'Nome do Passageiro' };
export const FILTRO_CPF = { chave: 'cpf', label: 'CPF' };
export const FILTRO_CPF_CNPJ = { chave: 'cpfCnpj', label: 'CPF/CNPJ' };
export const FILTRO_EMAIL = { chave: 'email', label: 'E-mail' };
export const FILTRO_PERFIL = { chave: 'perfil', label: 'Perfil' };
export const FILTRO_AGENCIA = { chave: 'agencia', label: 'Agência' };
export const FILTRO_AGENCIAS = { chave: 'agencias', label: 'Agências' };
export const FILTRO_NOME = { chave: 'nome', label: 'Nome' };
export const FILTRO_CONTRATANTE = { chave: 'contratante', label: 'Contratante' };
export const FILTRO_QUILOMETRAGEM = { chave: 'quilometragem', label: 'Quilometragem' };
export const FILTRO_VALOR_TOTAL = { chave: 'valor', label: 'Valor total' };
export const FILTRO_VEICULO_DESCRI = { chave: 'veiculo', label: 'Veiculo' };
export const FILTRO_NOME_USUARIO = { chave: 'nomeUsuario', label: 'Nome' };
export const FILTRO_USUARIO_SISTEMA = { chave: 'usuarioSistema', label: 'Usuário Integração'};
export const FILTRO_CODIGO_USUARIO = { chave: 'codigoUsuario', label: 'Codigo' };
export const FILTRO_EMAIL_USUARIO = { chave: 'emailUsuario', label: 'E-mail' };
export const FILTRO_STATUS_USUARIO = { chave: 'statusUsuario', label: 'Status' };
export const FILTRO_NOME_FANTASIA = { chave: 'nomeFantasia', label: 'Nome fantasia' };
export const FILTRO_EMPRESAS = { chave: 'empresas', label: 'Empresa' };
export const FILTRO_EMPRESA = { chave: 'empresa', label: 'Empresa' };
export const FILTRO_NOME_EMPRESA = { chave: 'nomeEmpresa', label: 'Nome fantasia empresa' };
export const FILTRO_TRECHO_ORIGEM = { chave: 'trechoOrigem', label: 'Trecho de Origem' };
export const FILTRO_TRECHO_DESTINO = { chave: 'trechoDestino', label: 'Trecho de Destino' };
export const FILTRO_ROTA = { chave: 'rota', label: 'Rota' };
export const FILTRO_SITUACAO_FECHAMENTO = { chave: 'situacoesFechamentoCaixa', label: 'Situação do Fechamento' };
export const FILTRO_SITUACAO_BPE = { chave: 'situacaoBPe', label: 'Situação BPE' };
export const FILTRO_LOCALIDADE = { chave: 'localidade', label: 'Localidade' };
export const FILTRO_UF = { chave: 'uf', label: 'UF' };
export const FILTRO_PREFIXO = { chave: 'prefixo', label: 'Prefixo' };
export const FILTRO_DELIMITACAO = { chave: 'delimitacao', label: 'Delimitação' };
export const FILTRO_CIDADE_ORIGEM = { chave: 'cidadeOrigem', label: 'Cidade de Origem' };
export const FILTRO_CIDADE_DESTINO = { chave: 'cidadeDestino', label: 'Cidade de Destino' };
export const FILTRO_CONFIGURACAO_BPE = { chave: 'configuracaoBPe', label: 'Configuração BPe' };
export const FILTRO_PLATAFORMA = { chave: 'plataforma', label: 'Plataforma' };
export const FILTRO_IDENTIFICACAO = { chave: 'identificacao', label: 'Identificação' };
export const FILTRO_TIPO = { chave: 'tipo', label: 'Tipo' };
export const FILTRO_VALIDO = { chave: 'valido', label: 'Válido' };
export const FILTRO_RESPONSAVEL = { chave: 'responsavel', label: 'Responsável' };
export const FILTRO_DATA_PARTIDA = { chave: 'dataPartida', label: 'Data da Partida' };
export const FILTRO_HORA_PARTIDA_ITINERARIO = { chave: 'horaPartida', label: 'Hora da Partida' };
export const FILTRO_VENDAS_ITINERARIO = { chave: 'itinerarioVenda', label: 'Itinerário'}
export const FILTRO_STATUS_ITINERARIO = { chave: 'statusItinerario', label: 'Situação' };
export const FILTRO_TIPO_CATEGORIA = { chave: 'tipoCategoria', label: 'Tipo Categoria'}
export const FILTRO_PRESTADOR = { chave: 'prestador', label: 'Prestador' };
export const FILTRO_VEICULO = { chave: 'veiculoDescricao', label: 'Veiculo' };
export const FILTRO_TIPO_AJUSTE = { chave: 'tipoAjuste', label: 'Tipo Ajuste'}
export const FILTRO_TIPO_CONFIGURACAO_PRECO = {chave: 'tipoConfiguracaoPreco', label: 'Regra de preço'}
export const FILTRO_PORCENTAGEM = {chave: 'porcentagem', label: 'Porcentagem'}
export const FILTRO_MOTORISTA = {chave: 'nomeMotorista', label: 'Motorista'}
export const FILTRO_NUMERO_RESERVA =  {chave: 'numeroReserva', label: 'Número do bilhete'}
export const FILTRO_GRUPO =  {chave: 'grupoEmpresa', label: 'Grupo'}
export const FILTRO_TIPO_PRECO = {chave: 'tipoPrecos', label: 'Categoria'}
export const FILTRO_SEGURO = {chave: 'temNumeroSeguro', label: 'Seguro'}
export const FILTRO_ORIGEM_REMARCACAO = {chave: 'origemRemarcacao', label: 'Aprovadas de Remarcação'}
export const FILTRO_NUMERO_SEGURO = { chave: 'numeroSeguro', label: 'Numero do Seguro' }
export const FILTRO_TIPO_PLANO = { chave: 'tipoPlano', label: 'Plano' }
export const FILTRO_NOME_AGENCIA = {chave: 'nomeAgencia', label: 'Agência'};
export const FILTRO_NOME_REMETENTE = {chave: 'nomeRemetente', label: 'Nome Remetente'}
export const FILTRO_DATA_COMPRA = {chave: 'dataCompra', label: 'Data da Compra'}
export const FILTRO_UF_BPE = { chave: 'ufBPe', label: 'UF BPe' };
export const FILTRO_ASSENTOS = {chave: 'quantidadeAssentos', label: 'Quantidade Assentos'}

export const FILTRO_DATA_EMISSAO_CTE_OS = { chave: 'dataEmissao', label: 'Data de Emissão' };
export const FILTRO_TOMADOR = { chave: 'tomador', label: 'Tomador'}
export const FILTRO_DESCRICAO_SERVICO_CTE_OS = { chave: 'descricaoServico', label: 'Decrição do Serviço' }
export const FILTRO_ID_CTE_OS = { chave: 'idCteOs', label: 'ID CT-E OS'}
export const FILTRO_NUMERO_CTE_OS = { chave: 'numero', label: 'Número CT-E OS'}
export const FILTRO_SERIE_CTE_OS = { chave: 'serie', label: 'Serie'}
export const FILTRO_VALOR_SERVICO = { chave: 'valorServico', label: 'valor Serviço'}
export const FILTRO_STATUS_CTE_OS = { chave: 'status', label: 'Status'}

export const FILTRO_MANUTENCAO_VEICULO_USUARIO = { chave: 'registradoPorUsuario', label: 'Registrador Por' };
export const FILTRO_TIPO_OCORRENCIA_MANUTENCAO_VEICULO =  { chave: 'tipoOcorrencia', label: 'Tipo Ocorrência'}
export const FILTRO_DATA_ENTRADA_MANUTENCAO_VEICULO = { chave: 'dataEntrada', label: 'Data Entrada'}
export const FILTRO_DATA_OCORRENCIA_MANUTENCAO_VEICULO = { chave: 'dataOcorrencia', label: 'Data Ocorrência'}

export const FILTRO_HABILITADO_VENDER_SITE = { chave: 'habilitadoVenderSite', label: 'Habilitado para Vender nos Sites' };

export const FILTRO_CENTRO_CUSTO_USUARIO = { chave: 'registradoPor', label: 'Registrado Por' };
export const FILTRO_TIPO_OCORRENCIA_CENTRO_CUSTO = { chave: 'tipoOcorrencia', label: 'Tipo Ocorrência' };
export const FILTRO_TIPO_EVENTO_OCORRENCIA_CENTRO_CUSTO = { chave: 'tipoEventoOcorrencia', label: 'Tipo Evento Ocorrência' };
export const FILTRO_TIPOS_OCORRENCIA_CENTRO_CUSTO = { chave: 'tipoOcorrencia', label: 'Tipo Ocorrência' };
export const FILTRO_DATA_ENTRADA_CENTRO_CUSTO = { chave: 'dataEntrada', label: 'Data Entrada' };
export const FILTRO_DATA_OCORRENCIA_CENTRO_CUSTO = { chave: 'dataOcorrencia', label: 'Data Ocorrência' };

export const FILTRO_STATUS_BAGAGEM = { chave: 'status', label: 'Status' };


export const FILTRO__USUARIO = { chave: 'registradoPor', label: 'Registrado Por' };


export function montarURLFiltro (filtros, pagina, registrosPorPagina) {
  let url = '';
  if (registrosPorPagina && pagina) {
    url = `?size=${registrosPorPagina}&from=${pagina}`;
  }

  if (!filtros) {
    return url
  }

  const concatenarURL = (filtro) => {
    if (filtro.isData) {
      if (filtro.valor.inicio !== '' && filtro.valor.fim !== '') {
        url += `${filtro.chave}Inicio=${filtro.valor.inicio}&`;
        url += `${filtro.chave}Fim=${filtro.valor.fim}&`
      }
    } else {
      url += filtro.valor.valor ? `${filtro.chave}=${filtro.valor.chave}&` : `${filtro.chave}=${filtro.valor}&`
    }
  };

  if (filtros.length > 0) {
    url += '&';
    filtros.forEach(concatenarURL)
  }
  return url
}

export const filtroExiste = (filtros, filtro) => {
  const entradasFiltro = filtros.filter(f => f.chave === filtro.chave && f.valor === filtro.valor);
  return entradasFiltro.length
};

export const filtroChaveValorJaExiste = (filtros, filtro) => {
  const entradasFiltro = filtros.filter(f => f.chave === filtro.chave && f.valor.chave === filtro.valor.chave);
  return entradasFiltro.length
};


export const alterouFiltro = (props, prevProps) => prevProps.filtrosAdicionados !== props.filtrosAdicionados;

export const alterouPagina = (props, prevProps) => prevProps.registrosPorPagina !== props.registrosPorPagina || prevProps.paginaAtual !== props.paginaAtual;


export const configuracaoMensagemAlerta = {
  position: 'top-left',
  effect: 'slide',
  timeout: 5000,
  html: true,
  offset: '80px',
  zIndex: '99999 !important'
};

export const configuracaoMensagemAlertaErro = {
  position: 'top-right',
  effect: 'slide',
  timeout: 15000,
  html: true,
  offset: '280px',
  zIndex: '99999 !important'
};
